import * as React from 'react'
import { SVGProps } from 'react'

const AVAXUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.765625' width='47' height='47' rx='23.5' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.436 7.39015C24.6045 5.95393 23.2817 5.95393 22.4502 7.39015L7.35097 33.9791C6.51947 35.4342 7.19979 36.587 8.86278 36.587H16.4407C17.9714 36.4925 19.351 35.6799 20.1825 34.3949L29.31 18.5776C29.9714 17.2169 29.9714 15.6106 29.31 14.25L26.5888 9.46889L25.436 7.39015ZM35.47 24.8892C34.6385 23.453 33.2968 23.453 32.4653 24.8892L27.1929 33.9789C26.3803 35.4152 27.0606 36.5868 28.7047 36.5868H39.1362C40.7992 36.5868 41.4795 35.4152 40.648 33.9789L35.47 24.8892Z'
      fill='#E84142'
    />
    <rect x='0.5' y='0.765625' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
  </svg>
)

export default AVAXUSD
